// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"c4325b76","213":"61a6ceca","333":"30cce11d","767":"fa98504d"}[chunkId] + ".chunk.js";
};